import { AnyAction } from '@reduxjs/toolkit';
import { GetAccountRepresentativesRoutine } from '../redux-routines';
import type { TAccountRepresentativesListState } from '../interfaces';

export const initialState: TAccountRepresentativesListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const accountRepresentativesListReducer = (
  state: TAccountRepresentativesListState = initialState,
  action: AnyAction,
): TAccountRepresentativesListState => {
  switch (action.type) {
    case GetAccountRepresentativesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: GetAccountRepresentativesRoutine.getSuccessPayload(action),
        error: null,
      };
    case GetAccountRepresentativesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GetAccountRepresentativesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: GetAccountRepresentativesRoutine.getFailurePayload(action),
      };

    default:
      return state;
  }
};
